import {
    focusedNewConversationsRollupText,
    otherNewConversationsRollupText,
} from './getRollupText.locstring.json';
import loc from 'owa-localize';
import InboxViewType from 'owa-service/lib/contract/InboxViewType';

/**
 * Get rollup text for current folder
 */
export default function getRollupText(viewType: InboxViewType): string {
    let rollupText;

    switch (viewType) {
        case InboxViewType.FocusedView:
            rollupText = loc(focusedNewConversationsRollupText);
            break;
        case InboxViewType.ClutterView:
            rollupText = loc(otherNewConversationsRollupText);
            break;
    }

    return rollupText;
}
